import { AxiosError } from 'axios';
import { useSnackbar } from 'notistack';
import { useTranslation } from 'react-i18next';
import { useMutation } from 'react-query';

import axios from './axios';
import extractNoneFieldErrors from 'src/utils/extractNonFieldErrors';

export interface UseUpdatePasswordVariables {
  old_password: string;
  password1: string;
  password2: string;
}

export interface UseUpdatePasswordData {}

export function useUpdatePassword() {
  const { t } = useTranslation();
  const { enqueueSnackbar } = useSnackbar();

  return useMutation<
    UseUpdatePasswordData,
    AxiosError<never>,
    UseUpdatePasswordVariables
  >(
    (variables) => {
      const data = {
        old_password: btoa(encodeURIComponent(variables.old_password)),
        password1: btoa(encodeURIComponent(variables.password1)),
        password2: btoa(encodeURIComponent(variables.password2)),
      };

      return axios
        .put<UseUpdatePasswordData>('/posht/ashena/update-password/', data)
        .then((res) => res.data);
    },
    {
      onError: (error) => {
        if (error.response?.status === 400) {
          enqueueSnackbar(
            extractNoneFieldErrors(error.response, t('landing.wrongPassword')),
            {
              variant: 'error',
            },
          );
        } else {
          enqueueSnackbar(t('errors.unknown'), { variant: 'error' });
        }
      },
      onSuccess: () => {
        enqueueSnackbar(t('landing.changePasswordSuccessful'), {
          variant: 'success',
        });

        // TODO: Logout
      },
    },
  );
}
